import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
// import App from "@lss/common";
import { App } from "@lss/common/src/index";
// const styles = StyleSheet.create({
//     box: { padding: 10 },
//     text: { fontWeight: 'bold' }
// });
// class App extends React.Component {
//     render() {
//         return (
//             <View style={styles.box}>
//                 <Text style={styles.text}>Hello, world!</Text>
//             </View>
//         );
//     }
// }

export default App;
